import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import ShareholderDetails from '../../components/admincomponents/ShareholderDetails';

function ViewProject({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ShareholderDetails />            
    </>
  );
}

export default ViewProject;
